import { render, staticRenderFns } from "./PsychologyForm.vue?vue&type=template&id=978ea3cc&"
import script from "./PsychologyForm.vue?vue&type=script&lang=js&"
export * from "./PsychologyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports